/*
Copyright (c) 2026 Wind River Systems, Inc.

The right to copy, distribute, modify, or otherwise make use of this software may be licensed only pursuant to the terms of an applicable Wind River license agreement.
*/
import { Injectable } from '@angular/core';
import { SearchUserResult } from '@models';

// A central place to access things we put in local storage. At this time, that's only
// the list of recently impersontated customers. As with all local storage, all methods
// are synchronous.
@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {
  private static readonly recentUsersKey = 'RecentUsers';
  private static readonly maxRecentUsers = 10;

  // Add the recent user, if the user is already in the list, they will be moved to the top
  public addRecentUser(user: SearchUserResult): void {
    let users: SearchUserResult[] = this.getRecentUsers();

    // If the user is already in the list, remove them.
    users = users.filter((u) => u.user_id !== user.user_id);

    // Put this user at the top of the list
    users.unshift(user);

    // Limit the list size
    users.splice(LocalStorageService.maxRecentUsers);

    // Store the new list
    localStorage.setItem(LocalStorageService.recentUsersKey, JSON.stringify(users));
  }

  public getRecentUsers(): SearchUserResult[] {
    const json: string = localStorage.getItem(LocalStorageService.recentUsersKey);
    return json ? JSON.parse(json) : [];
  }
}
